import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  descricao: '',
  ativo: null,
};

export const RegiaoEntidadeContext = createContext();

export const RegiaoEntidadeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [regiaoEntidade, setRegiaoEntidade] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getRegiaoEntidade = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: regiaoEntidade?.filter,
        page: regiaoEntidade?.page,
        size: regiaoEntidade?.size,
        order: regiaoEntidade?.order,
        ...payload,
      });
      setRegiaoEntidade((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <RegiaoEntidadeContext.Provider
      value={{
        getLoading,
        regiaoEntidade,
        getRegiaoEntidade,
      }}
    >
      {children}
    </RegiaoEntidadeContext.Provider>
  );
};
